import React, { HTMLAttributes, ReactNode } from "react";
import cn from "classnames";
import "./BMJTypography.scss";
// import { Typography } from "@mui/material";
// import { colors } from "../../../constant/cssVariable";



type Variant =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "subheading1"
  | "subheading2"
  | "body1"
  | "body2"
  | "subtitle1"
  | "subtitle2"
  | "body3";


  type Color =
  | "error"
  | "success"
  | "warning"
  | "primary"
  | "secondary"
  | "info"
  | "white";

interface BMJTypographyProps extends HTMLAttributes<HTMLElement> {
  variant: Variant;
  color?: Color;
  className?:string;
  children: ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const variantsMapping: Record<Variant, keyof JSX.IntrinsicElements | any> = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subheading1: "h6",
    subheading2: "h6",
    body1: "p",
    body2: "p",
    body3: "p",
    subtitle1: "span",
    subtitle2: "span",
  };

// Create a functional component that take 
// variant: the selected html tag
// color: the selected color
// children: the node passed inside the Component
// ...props: the default attribute of the Component
const BMJTypography: React.FC<BMJTypographyProps>     = ({ variant, color="", className,children, ...props }) => {
// If the variant exists in variantsMapping, we use it. 
// Otherwise, use p tag instead.
  const Component = variant ? variantsMapping[variant] : "p";

  return (
    <Component
      className={cn({
        [`typography--variant-${variant}`]: variant,
        [`typography--color-${color}`]: color,
        [`typography--nowrap-${color}`]: color,
      }, className)
    }
      {...props}
    >
      {children}
    </Component>
  );
};

export default BMJTypography;